import React, { useEffect } from "react";
import { useState } from "react";
import { Box, File, FileText, List, Paperclip, Pocket, Settings, User, Users } from "react-feather";
import TopBar from "../../components/menu/TopBar";
import Menu from "./detailsSideMenu.jsx/Menu";
import AppTabs from "./tabsForAppDetails/AppTabs";
import AuthorizedPerson from "./tabsForAppDetails/AuthorizedPerson";
import Claims from "./tabsForAppDetails/Claims";
import Correspondence from "./tabsForAppDetails/Correspondence";
import Insurance from "./tabsForAppDetails/Insurance";
import Medical from "./tabsForAppDetails/Medical";
import PatientInformation from "./tabsForAppDetails/PatientInformation";
import PharmacyCard from "./tabsForAppDetails/PharmacyCard";
import UploadDocuments from "./tabsForAppDetails/UploadDocuments";
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { appViewDetails, resetAppViewDetails, resetDataFetched, resetInitialTab } from "../../stores/slices/appViewDetailsSlice";
import { fetchDocList } from "../../utilities/API/document/documentAPI";
import { fetchAppDocList } from "../../stores/slices/document/documentListSlice";
import Loader from "../../components/menu/Loader";
import { fetchAppClaimList, fetchClaimList, resetClaimList } from "../../stores/slices/claimIntake/claimListSlice";
import { resetClaimIntakeData } from "../../stores/slices/claimIntake/claimIntakeSlice";
import { getAllSessions } from "../../utilities/API/supertokenServices";

function Appdetails() {
  const dispatch = useDispatch();
  const loginData = useSelector((state) => state.loginSlice);
  const sessionData = useSelector((state) => state.sessionSlice)
  const applicationData = useSelector((state) => state.appViewDetailsSlice);
  const [appDetails, setAppDetails] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);
  const [loader, setLoader] = useState(true)

  const docList = () => {
    dispatch(fetchAppClaimList({ appID: applicationData.viewAppInfo.applicationId, ein: loginData.value.EIN, prgData: applicationData.program }))
    setSelectedTab(applicationData.initialTab)
    let data = {
      portalUserID: loginData.value.PortalUserID,
      applicationID: applicationData.viewAppInfo.applicationId,
      EmailAddress: loginData.value.EmailAddress,
      ReferenceID: loginData.value.EIN,

    }
    let claimLabel = applicationData.program == 'CPR' ? 'Claims' : 'Payments';
    let pharmacyCardLabel = applicationData.program == 'CPR' ? (applicationData.isPDMI ? 'Application Status / Pharmacy Card ' : 'Application Status') : 'Application Status'

    setAppDetails([
      {
        id: 1,
        icon: <User />,
        menuLabel: 'Patient Information',
        component: <PatientInformation />
      },
      {
        id: 2,
        icon: <Users />,
        menuLabel: 'Authorized Person Information',
        component: <AuthorizedPerson />
      },
      {
        id: 3,
        icon: <Box />,
        menuLabel: applicationData.program == "CPR" ? "Insurance Details" : 'Insurance Information',
        component: <Insurance />
      },
      {
        id: 4,
        icon: <Pocket />,
        menuLabel: 'Physician/ Diagnosis  Information',
        component: <Medical />
      },
      {
        id: 5,
        icon: <Paperclip />,
        menuLabel: 'Upload Documents',
        component: <UploadDocuments />
      },
      {
        id: 6,
        icon: <List />,
        menuLabel: 'Correspondence',
        component: <Correspondence />
      },
      {
        id: 7,
        icon: <FileText />,
        menuLabel: claimLabel,
        component: <Claims />
      },
      {
        id: 8,
        icon: <Settings />,
        menuLabel: pharmacyCardLabel,
        component: <PharmacyCard />
      }

    ])
      dispatch(fetchAppDocList({ appData: data, prgData: applicationData.program }))

    setLoader(false);
    dispatch(resetDataFetched())
  }

  applicationData.isDataFetched && docList()

  useEffect(() => {
    dispatch(resetClaimList())
    dispatch(resetClaimIntakeData())
    setAppDetails([

      {
        id: 1,
        icon: <User />,
        menuLabel: 'Patient Information',
        component: <PatientInformation />
      },
      {
        id: 2,
        icon: <Users />,
        menuLabel: 'Authorized Person Information',
        component: <AuthorizedPerson />
      },
      {
        id: 3,
        icon: <Box />,
        menuLabel: applicationData.program == "CPR" ? "Insurance Details" : 'Insurance Information',
        component: <Insurance />
      },
      {
        id: 4,
        icon: <Pocket />,
        menuLabel: 'Physician/ Diagnosis  Information',
        component: <Medical />
      },
      {
        id: 5,
        icon: <Paperclip />,
        menuLabel: 'Upload Documents',
        component: <UploadDocuments />
      },
      {
        id: 6,
        icon: <List />,
        menuLabel: 'Correspondence',
        component: <Correspondence />
      },
      {
        id: 7,
        icon: <FileText />,
        menuLabel: 'Claims',
        component: <Claims />
      },
      {
        id: 8,
        icon: <Settings />,
        menuLabel: 'Application Status',
        component: <PharmacyCard />
      }

    ])
    return () => {
      dispatch(resetAppViewDetails());
      dispatch(resetInitialTab(1))
    };

  }, [])

  const onClickSlectedtab = (id) => {
    setSelectedTab(id);
  }

  return (
    <div className="content">
      <TopBar />
      <div class="intro-y box px-5 pt-5 mt-5">
        {loader && <Loader />}

        <div class="d-flex flex-column flex-lg-row border-bottom border-gray-200 dark-border-dark-5 pb-5 mx-n5">
          <div class="d-flex flex-1 px-5 align-items-center justify-content-center justify-content-lg-start">
            <div class="ms-1">
              <div class="w-24 w-sm-40 fw-medium fs-lg">{applicationData.viewAppInfo.applicationId}</div>
              <div class="grid">
                <div class={`py-1 px-5 g-col-5 rounded-pill fs-xs ${applicationData.viewAppInfo.appStatus == 'Denied' ? `bg-theme-6` : applicationData.viewAppInfo.appStatus == 'Pending' ? `bg-yellow` : applicationData.viewAppInfo.appStatus == 'Approved' ? `bg-theme-9` : `bg-default`} text-white cursor-pointer fw-medium`}>
                  {applicationData.viewAppInfo.appStatus}
                </div>
              </div>
            </div>
          </div>
          <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 px-5 border-start border-end border-gray-200 dark-border-dark-5 border-top border-top-lg-0 pt-5 pt-lg-0">
            <div class="fw-medium text-lg-start mt-lg-3 px-2">Award Info</div>
            <div class="d-flex flex-column  mt-4">
              <div class="truncate white-space-sm-normal d-flex align-items-center  px-2">
                {" "}
                Fund Applied for :{" "}
                <div class="text-gray-600 px-2">{applicationData.viewAppInfo.fundDisplayName}</div>
              </div>
              <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">
                Program : <div class="text-gray-600 px-2"> {applicationData.program == "CPR" ? "TotalAssist" : applicationData.program}</div>{" "}
              </div>
              <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">
                {" "}
                Award Year : <div class="text-gray-600 px-2">{applicationData.viewAppInfo.awardYear} </div>
              </div>
              <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">
                {" "}
                Patient Balance :{" "}
                <div class="text-gray-600 px-2">{`$ ${Number.parseFloat(applicationData.viewAppInfo.balance).toFixed(2)}`} </div>
              </div>
            </div>
          </div>
          <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 px-5 border-start border-end border-gray-200 dark-border-dark-5 border-top border-top-lg-0 pt-5 pt-lg-0">
            <div class="d-flex flex-column  mt-8">
              <div class="truncate white-space-sm-normal d-flex align-items-center mt-4 px-2">
                {" "}
                Effective Date :{" "}
                <div class="text-gray-600 px-2">{applicationData.viewAppInfo.effStartDate_date}</div>
              </div>
              <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">
                LookbackDate :
                <div class="text-gray-600 px-2"> {applicationData.viewAppInfo.lookbackDate}</div>{" "}
              </div>
              <div class="truncate white-space-sm-normal d-flex align-items-center mt-4 px-2">
                {" "}
                Revoke Date :{" "}
                <div class="text-gray-600 px-2">{applicationData.viewAppInfo.RevokeDate}</div>
              </div>
              <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">
                {" "}
                Expiry Date :{" "}
                <div class="text-gray-600 px-2"> {applicationData.viewAppInfo.expiryDate}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid columns-12 gap-6 pb-6">
          <div class="g-col-12 g-col-lg-4 g-col-xxl-3 d-flex d-lg-block flex-column-reverse">
            <div class="intro-y box mt-5">
              <div class="position-relative d-flex align-items-center p-5">
                <div class="ms-1 me-auto">
                  <div class="fw-medium fs-base">{applicationData.patientInfo.patientName}</div>
                  <div class="truncate white-space-sm-normal d-flex align-items-center mt-1">
                    {" "}
                    Patient Id : <div class="text-gray-600 px-2">{applicationData.patientInfo.patientId}</div>
                  </div>
                </div>
              </div>
              <Menu data={appDetails} selected={selectedTab} onClickSelect={onClickSlectedtab} />
            </div>
          </div>
          <AppTabs data={appDetails} selected={selectedTab} />
        </div>
      </div>
    </div>
  );
}

export default Appdetails;
